module.exports = __webpack_public_path__ + "img/mega.6bc1147d.svg";